import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Spinner, InputGroup } from 'react-bootstrap';
import { useEntidadeContext } from '../../EntidadeContext';
import { useAlertModal } from '../../AlertModalContext';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

// Adiciona os ícones de marcas à biblioteca para que possam ser usados
library.add(faInstagram, faFacebook, faLinkedin);

const RedesSociaisTab = () => {
    const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
    const { showAlertModal } = useAlertModal();
    const [formData, setFormData] = useState({
        instagram_url: '',
        facebook_url: '',
        linkedin_url: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isChanged, setIsChanged] = useState(false);

    useEffect(() => {
        if (currentEntidade) {
            setFormData({
                instagram_url: currentEntidade.instagram_url || '',
                facebook_url: currentEntidade.facebook_url || '',
                linkedin_url: currentEntidade.linkedin_url || '',
            });
            setIsChanged(false);
        }
    }, [currentEntidade]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setIsChanged(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // BACKEND: Você precisará de um endpoint para salvar estes dados.
            // Ex: PUT /api/entidades/{id}/redes-sociais
            const response = await axios.put(`/api/entidades/${currentEntidade.id}/redes-sociais`, formData);
            setCurrentEntidade(response.data.entidade);
            showAlertModal('Sucesso', 'Links das redes sociais atualizados!', 'success');
            setIsChanged(false);
        } catch (error) {
            showAlertModal('Erro', 'Não foi possível salvar os links.', 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Card>
            <Card.Header>
                <Card.Title>Links das Redes Sociais</Card.Title>
            </Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Instagram</Form.Label>
                        <InputGroup><InputGroup.Text><FontAwesomeIcon icon={['fab', 'instagram']} /></InputGroup.Text><Form.Control type="url" name="instagram_url" value={formData.instagram_url} onChange={handleChange} placeholder="https://www.instagram.com/seuperfil" /></InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Facebook</Form.Label>
                        <InputGroup><InputGroup.Text><FontAwesomeIcon icon={['fab', 'facebook']} /></InputGroup.Text><Form.Control type="url" name="facebook_url" value={formData.facebook_url} onChange={handleChange} placeholder="https://www.facebook.com/suapagina" /></InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>LinkedIn</Form.Label>
                        <InputGroup><InputGroup.Text><FontAwesomeIcon icon={['fab', 'linkedin']} /></InputGroup.Text><Form.Control type="url" name="linkedin_url" value={formData.linkedin_url} onChange={handleChange} placeholder="https://www.linkedin.com/company/suaempresa" /></InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-end">
                        <Button variant="primary" type="submit" disabled={isLoading || !isChanged}>{isLoading ? <><Spinner as="span" size="sm" /> Salvando...</> : 'Salvar Links'}</Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default RedesSociaisTab;